import { render, staticRenderFns } from "./CreateDocumentView.vue?vue&type=template&id=6a67aed7"
import script from "./CreateDocumentView.vue?vue&type=script&lang=js"
export * from "./CreateDocumentView.vue?vue&type=script&lang=js"
import style0 from "./CreateDocumentView.vue?vue&type=style&index=0&id=6a67aed7&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./CreateDocumentView.vue?vue&type=style&index=2&id=6a67aed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports